import { useEffect } from 'react'
import { MatriculaStore } from './MatriculasStore'
import { formatMoeda } from '../common/Utils'
import { Show } from '../components/Show'

export function Cupom() {
  const dispatch = MatriculaStore.useDispatch()
  const { cupom, cupomMessagemErro } = MatriculaStore.useState()
  const search = window.location.search
  const params = new URLSearchParams(search)
  const cupomParams = params.get('cupom')

  useEffect(() => {
    if (cupomParams) {
      dispatch(MatriculaStore.thunks.getCupom({ codigo: cupomParams }))
    }
  }, [cupomParams])

  return (
    <>
      <Show condition={!!cupom?.id}>
        <>
          <strong>Cupom: {cupom?.codigo}</strong>
          {cupom?.valorDesconto && (
            <div>
              Você ganhou <strong>R$ {formatMoeda(cupom.valorDesconto)}</strong> de desconto na sua
              matrícula
            </div>
          )}
          {cupom?.percentualDesconto && (
            <div>
              Você ganhou{' '}
              {cupom.percentualDesconto && <strong> {cupom.percentualDesconto}%</strong>} de
              desconto na sua matrícula
            </div>
          )}
        </>
      </Show>
      <Show condition={!!cupomMessagemErro}>
        <>
          <strong style={{ color: 'red' }}>{cupomMessagemErro}</strong>
        </>
      </Show>
    </>
  )
}
